export default __webpack_public_path__ + "static/media/nfto.ef7b1e2d.gif";